import { TypesafeStructuredText } from "datocms-structured-text-utils"
import { graphql, useStaticQuery } from "gatsby"

import { IconType } from "../../../design-system/feather-icon/feather-icon-map"
import { usePageContext } from "../../../utils/contexts/page-context"
import { pathMatchesPattern } from "./utils"

export interface DatoCmsAnnouncementBar {
  icon: {
    iconType: IconType
  }
  message: TypesafeStructuredText
  pathPatterns: string[]
  priorityLevel: string // This is a string field on Dato with regex to force it to be numerical. Dato doesn't have the option to enforce uniqueness for number fields.
}

export interface AnnouncementBarQuery {
  datoCms: {
    allAnnouncementBars: DatoCmsAnnouncementBar[]
  }
}

export const useAnnouncementBar = (): DatoCmsAnnouncementBar => {
  const {
    datoCms: { allAnnouncementBars },
  } = useStaticQuery<AnnouncementBarQuery>(graphql`
    query AnnouncementBarsQuery {
      datoCms {
        allAnnouncementBars(filter: { active: { eq: true } }) {
          message {
            value
            links {
              __typename
              id
              format
              link
              value {
                title
                baseValue
                unit
              }
            }
          }
          icon {
            iconType
          }
          pathPatterns
          priorityLevel
        }
      }
    }
  `)

  const { pathname } = usePageContext()

  const visibleAnnouncementBars = allAnnouncementBars
    .filter(bar =>
      bar.pathPatterns.some(pathPattern =>
        pathMatchesPattern(pathname, pathPattern),
      ),
    )
    .sort((a, b) => Number(b.priorityLevel) - Number(a.priorityLevel))

  return visibleAnnouncementBars[0]
}
